const AFRAME = window.AFRAME;
// const THREE = AFRAME.THREE;

AFRAME.registerComponent( 'zoom_controls', {
	schema: {
		startValue: { type: 'number', default: 1 },
		minValue: { type: 'number', default: 0.8 },
		maxValue: { type: 'number', default: 3 }
	},

	init() {

		// initialize with correct zoom value
		this.camera3D = this.el.getObject3D( "camera" );
		this.camera3D.zoom = this.data.startValue;
		this.camera3D.updateProjectionMatrix();

		// setup listener for scrolling
		document.addEventListener( 'wheel', ( e ) => {

			if ( e.deltaY > .1 ) { // scroll up

				if ( this.camera3D.zoom > this.data.minValue ) {

					// zoom out
					this.camera3D.zoom -= 0.04;
					this.camera3D.updateProjectionMatrix();

				}

			} else if ( e.deltaY < - .1 ) { // scroll down

				if ( this.camera3D.zoom < this.data.maxValue ) {

					//  zoom in
					this.camera3D.zoom += 0.04;
					this.camera3D.updateProjectionMatrix();

				}

			}

		} );

	},

} );
